"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPageFileType = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsAltBox = require("../../components/DmsAltBox/DmsAltBox");
var _DmsButtonGroup = require("../../components/DmsButtonGroup/DmsButtonGroup");
var _DmsTable = require("../../components/DmsTable/DmsTable");
var _DmsTableCreateButton = require("../../components/DmsTableButton/DmsTableCreateButton");
var _DmsTableDeleteButton = require("../../components/DmsTableButton/DmsTableDeleteButton");
var _DmsTableEditButton = require("../../components/DmsTableButton/DmsTableEditButton");
var _DmsPage = require("../../components/DmsPage/DmsPage");
var _DmsPermissions = require("../../components/DmsPermissions/DmsPermissions");
var _DmsFlexContainer = require("../../components/DmsFlexContainer/DmsFlexContainer");
var _DmsExport = require("../../components/DmsExport/DmsExport");
var _Permissions = require("../../constants/Permissions");
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * DmsPageFileType Component
 * 
 * @description This component renders the File Type page. It displays a DmsPage layout with a DmsAltBox containing a DmsTable component.
 * 
 * @component
 * @example
 * return (
 *   <DmsPageFileType />
 * )
 * 
 * @returns {JSX.Element} The File Type page.
 */
const DmsPageFileType = () => {
  const table = (0, _react.useRef)(null);
  const header = [{
    label: _reactIntlUniversal.default.get("Name").d("Name"),
    column_name: "name",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Type").d("Type"),
    column_name: "type_",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Actions").d("Actions"),
    permissions: [_Permissions.Permissions.CAN_EDIT_FILE_TYPE],
    width: "80px",
    sortable: false,
    element: row => {
      const name = row.name;
      return /*#__PURE__*/_react.default.createElement(_DmsButtonGroup.DmsButtonGroup, null, /*#__PURE__*/_react.default.createElement(_DmsTableEditButton.DmsTableEditButton, {
        row: row,
        table: table,
        title: _reactIntlUniversal.default.get("UpdateFileType_name", {
          name
        }).d("Update {name}"),
        url: "/file_type/"
      }), /*#__PURE__*/_react.default.createElement(_DmsTableDeleteButton.DmsTableDeleteButton, {
        table: table,
        title: _reactIntlUniversal.default.get("DeleteFileType_name", {
          name
        }).d("Delete {name}"),
        text: _reactIntlUniversal.default.get("DmsPageFileType.DeleteButtonMessage", {
          name
        }).d("The File Type {name} will be deleted. Are you sure about it?"),
        url: "/file_type/"
      }));
    }
  }];
  const toolbar = /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer, null, /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Left, null, /*#__PURE__*/_react.default.createElement(_DmsPermissions.DmsPermissions, {
    permissions: [_Permissions.Permissions.CAN_EDIT_FILE_TYPE]
  }, /*#__PURE__*/_react.default.createElement(_DmsTableCreateButton.DmsTableCreateButton, {
    table: table,
    title: _reactIntlUniversal.default.get("CreateFileType").d("Create File Type"),
    url: "/file_type/",
    header: header
  }))), /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Right, null, /*#__PURE__*/_react.default.createElement(_DmsExport.DmsExport, {
    table: table
  })));
  return /*#__PURE__*/_react.default.createElement(_DmsPage.DmsPage, {
    name: "File Type"
  }, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    sx: {
      fontSize: '1.1rem'
    }
  }, _reactIntlUniversal.default.get("FileType").d("File Type"))), /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Body, null, /*#__PURE__*/_react.default.createElement(_DmsTable.DmsTable, {
    ref: table,
    url: "/file_type/table",
    header: header,
    needs_authentication: true,
    managed: true,
    toolbar: toolbar
  }))));
};
exports.DmsPageFileType = DmsPageFileType;